function FilterItems(needle, heystack, nat) {
  var query = needle.toLowerCase();
  return heystack.filter(function (item) {
    return item[nat].toLowerCase().indexOf(query) >= 0;
  });
}
export default FilterItems;
